import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { TextHtmlTagType, generalAudioCaching, getGlobalTextSizeStyle } from '../../misc/tools';

import "./button1.css"

const Button1 = (props: Button1ConfigMain) => {
	const [isHovering, setIsHovering] = useState(false);
	const getBgColor = () => {
		return props.props.bgColor ?? undefined;
	}
	return (
		<div className={`center-element-horizontal main-content-inner button1-container ${props.props.customClass ? props.props.customClass : ''}`} tabIndex={props.props.disabled ? -1 : 0} aria-label={props.props.buttonText} style={{
			width: props.props.width,
			height: props.props.height,
			backgroundColor: props.props.isSelected ? 'gray' : (isHovering ? props.props.hoverColor ?? getBgColor() : getBgColor()),
			opacity: props.props.disabled ? 0.5 : 1,
			pointerEvents: props.props.disabled ? 'none' : 'all'
		}} onMouseEnter={() => {
			setIsHovering(true);
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
			Tools.playOneShotSound(url);
		}} onMouseLeave={() => {
			setIsHovering(false);
		}} onKeyUp={Tools.mapDivEnterToClick} data-testid="test-button-1" onClick={() => {
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.digi_plink_01).src;
			Tools.playOneShotSound(url);
			if(props.props.onClick) {
				props.props.onClick()
			}
		}} id={props.props.idFor508}>
			<div className={props.props.mainMenu ? ('button1-container-img2') : ('button1-container-img')} style={ props.props.imgOnRight ? {
				marginLeft: '0',
				marginRight: '20px',
				position: 'absolute',
				right: props.props.imgRight,
				width: props.props.imgWidth
			} : {}}>
				<img className='center-element' alt={props.props.alt508} src={props.props.imgSrc}/>
			</div>
			<div>
				{props.props.mainMenu ? (
					<div className='button1-container-text2 default-text center-element-vertical'>{props.props.buttonText2(isHovering)}</div>
				) : (
					<p style={ props.props.imgOnRight ? {
						right: 'unset',
						left: props.props.imgTextLeft,
						...getGlobalTextSizeStyle(TextHtmlTagType.p)
					} : {...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='button1-container-text default-text center-element-vertical'>{props.props.buttonText}</p>
				)}
				
			</div>
		</div>
	);
};

export interface Button1ConfigMain {
	props: Button1Config
}

export interface Button1Config {
	imgSrc?: string;
	idFor508?: string;
	alt508?: string;
	buttonText?: string;
	buttonText2?: (isHovering?: boolean) => any;
	onClick?: () => void;
	width?: string;
	height?: string;
	imgWidth?: string;
	imgRight?: string;
	imgTextLeft?: string;
	isSelected?: boolean;
	imgOnRight?: boolean;
	mainMenu?: boolean;
	hoverColor?: string;
	bgColor?: string;
	disabled?: boolean;
	customClass?: string;
}

export default Button1;